import React, { useState, useEffect } from "react";
import ReportsTable from "./components/ReportsTable";
import { CardBody, Container, Card } from "reactstrap";
import useAxios from "hooks/useAxios";
import { onExport, getUpdatedFilterLatest } from "utils/helper";
import useContextService from "hooks/useContextService";
import ErrorBoundary from "components/ErrorBoundary";
import ReportClaimTable from "./components/ReportsTable/ReportClaimTable";
import ReportReplenishedTable from "./components/ReportsTable/ReportReplenishedTable";
import ReportNonReplenishedTable from "./components/ReportsTable/ReportNonReplenishedTable";
import ReportInvoicedClaimsTable from "./components/ReportsTable/ReportInvoicedClaimsTable";
import ReportPODetailsTable from "./components/ReportsTable/ReportPODetailsTable";
import { filter, cloneDeep } from "lodash";
import NonDerivedClaimTable from "./components/ReportsTable/NonDerivedClaimTable";
import SearchReports from "./components/SearchReports";
import Loader from "components/Loader";


let filters = [];
let pageFilters = {};

const Reports = () => {
  const API = useAxios();
  const [data, setData] = useState([]);
  const [totalItem, setTotalItem] = useState(0);
  const [reportType, setReportType] = useState(1);
  const [loading, setLoading] = useState(false);
  const [collapseSider, setcollapseSider] = useState(false);
  const [columnFilters, setColumnFilters] = useState([]);
  const {
    states: { reports },
    setStates,
  } = useContextService();
  const { search, thirdPartyAdmin, searchTerms } = reports;
  const { thirdPartyAdminID } = thirdPartyAdmin;
  const { tenantID } = thirdPartyAdmin;

  useEffect(() => {
    if (searchTerms.thirdPartyAdminID) handleSearch(searchTerms);
  }, []);


const formatEndDate = (inputDate) => {
  return `${inputDate} 23:59:59`;
};


  const handleSearch = async (filter) => {
    const {
      thirdPartyAdminID,
      pharmacyIDs,
      coveredEntityID,
      coveredEntityIDS,
      startDate,
      endDate,
      reportType,
      selectedReportType,
      statusTypeId,
      claimTypeId,
      daterangeid,
      dateRangeID
    } = filter;
    pageFilters = { ...filter };
    pageFilters.pharmacyIDs = Array.isArray(pharmacyIDs)
      ? pharmacyIDs
      : [pharmacyIDs];
    setReportType(reportType);
    var phIds = [];
    if (pharmacyIDs?.length === 0 && searchTerms?.pharmacyids.length !== undefined && searchTerms?.pharmacyids.length > 0) {
      phIds = Array.isArray(filter.pharmacyids)
    ? filter.pharmacyids.map(item => item["value"])
    : [];
    }
    else {
      phIds = pharmacyIDs;
    }
    var covids = [];
    if (coveredEntityIDS === undefined && searchTerms.ceIds.length !== undefined && searchTerms.ceIds.length > 0) {
      covids = Array.isArray(filter.ceIds)
      ? filter.ceIds.map(item => item["value"])
      :[];
    }
    else {
      covids = coveredEntityIDS;
    }
    const formattedEndDate = formatEndDate(endDate);


    pageFilters.pharmacyIDs = phIds;
    pageFilters.coveredEntityIDS = covids;
    pageFilters.startDate = startDate;
    pageFilters.endDate = endDate;
    
    //setColumnFilters(pageFilters);
    delete pageFilters.ceIds;
    delete pageFilters.pharmacyids;
    //const tableRes = document.querySelector('.table-responsive');
    //tableRes.scrollLeft = 0;
    search.ClaimTypeId = claimTypeId;
    search.statusTypeId = statusTypeId;
    search.daterangeid = dateRangeID;
    search.reportType = selectedReportType;
    await handlefetchbasedOnreportType(reportType, search);
  };

  const handlefetchbasedOnreportType = async (reportType, filters) => {
    
    if (reportType == 1) await fetchClaimsReport(filters);
    if (reportType == 2) await fetchReplenishedReport(filters);
    if (reportType == 3) await fetchNonReplenishedReport(filters);
    if (reportType == 4) await fetchInvoicedReport(filters);
    if (reportType == 5) await fetchPOReport(filters);
    if(reportType == 6 ) await fetchNonDerivedReport(filters);
  };

  const fetchClaimsReport = async (filters) => {
    setLoading(true);
    if (!thirdPartyAdminID) return null;
    try {
      if (
        Array.isArray(pageFilters.pharmacyIDs) &&
        pageFilters.pharmacyIDs[0] === ""
      ) {
        pageFilters.pharmacyIDs = [];
        pageFilters.pharmacyIDs.length === 0;
      }
      let Allfilters = { ...pageFilters };
       Allfilters.filters = { ...filters };
      const { data } = await API.post(
        `/${tenantID}/Reports/ClaimReports`,
        Allfilters
      );
      if (data) {
        setData(data.items);
        setTotalItem(data.totalRecords);
        setLoading(false);
      } else {
        setData([]);
        setTotalItem(0);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const fetchPOReport = async (filters) => {
    setLoading(true);
    if (!thirdPartyAdminID) return null;
    try {
      if (
        Array.isArray(pageFilters.pharmacyIDs) &&
        pageFilters.pharmacyIDs[0] === ""
      ) {
        pageFilters.pharmacyIDs = [];
        pageFilters.pharmacyIDs.length === 0;
      }
      let Allfilters = { ...pageFilters };
      Allfilters.filters = { ...filters };
      const { data } = await API.post(
        `/${tenantID}/Reports/POReports`,
        Allfilters
      );
      if (data) {
        setData(data.items);
        console.log(data.items[0]);
        setTotalItem(data.totalRecords);
        setLoading(false);
      } else {
        setData([]);
        setTotalItem(0);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const fetchInvoicedReport = async (filters) => {
    setLoading(true);
    if (!thirdPartyAdminID) return null;
    try {
      if (
        Array.isArray(pageFilters.pharmacyIDs) &&
        pageFilters.pharmacyIDs[0] === ""
      ) {
        pageFilters.pharmacyIDs = [];
        pageFilters.pharmacyIDs.length === 0;
      }
      let Allfilters = { ...pageFilters };
      Allfilters.filters = { ...filters };
      const { data } = await API.post(
        `/${tenantID}/Reports/InvoicedReports`,
        Allfilters
      );
      if (data) {
        setData(data.items);
        setTotalItem(data.totalRecords);
        setLoading(false);
      } else {
        setData([]);
        setTotalItem(0);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const fetchReplenishedReport = async (filters) => {
    setLoading(true);
    if (!thirdPartyAdminID) return null;
    try {
      if (
        Array.isArray(pageFilters.pharmacyIDs) &&
        pageFilters.pharmacyIDs[0] === ""
      ) {
        pageFilters.pharmacyIDs = [];
        pageFilters.pharmacyIDs.length === 0;
      }
      let Allfilters = { ...pageFilters };
      Allfilters.filters = { ...filters };

      const { data } = await API.post(
        `/${tenantID}/Reports/ReplenishedReports`,
        Allfilters
      );

      if (data) {
        setData(data.items);
        setTotalItem(data.totalRecords);
        setLoading(false);
      } else {
        setData([]);
        setTotalItem(0);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const fetchNonReplenishedReport = async (filters) => {
    setLoading(true);
    if (!thirdPartyAdminID) return null;
    try {
      if (
        Array.isArray(pageFilters.pharmacyIDs) &&
        pageFilters.pharmacyIDs[0] === ""
      ) {
        pageFilters.pharmacyIDs = [];
        pageFilters.pharmacyIDs.length === 0;
      }
      let Allfilters = { ...pageFilters };
      Allfilters.filters = { ...filters };
      const { data } = await API.post(
        `/${tenantID}/Reports/NonReplenishedReports`,
        Allfilters
      );
      if (data) {
        setData(data.items);
        setTotalItem(data.totalRecords);
        setLoading(false);
      } else {
        setData([]);
        setTotalItem(0);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const fetchNonDerivedReport = async (filters) => {
    setLoading(true);
    if (!thirdPartyAdminID) return null;
    try {
      if (
        Array.isArray(pageFilters.pharmacyIDs) &&
        pageFilters.pharmacyIDs[0] === ""
      ) {
        pageFilters.pharmacyIDs = [];
        pageFilters.pharmacyIDs.length === 0;
      }
      let Allfilters = { ...pageFilters };
      Allfilters.filters = { ...filters };
      const { data } = await API.post(
        `/${tenantID}/Reports/NonDerivedClaims`,
        Allfilters
      );
      if (data) {
        setData(data.items);
        setTotalItem(data.totalRecords);
        setLoading(false);
      } else {
        setData([]);
        setTotalItem(0);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const refetch = (hasReset) => {
    if (hasReset) {
      search.filters = [];
      setColumnFilters([]);
      handleSearch(searchTerms);
    }
  };
  

  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    }
  };

  const handlePOExport = async () => {
     const filterObj = cloneDeep(search);
      if (columnFilters && columnFilters.length > 0) {
        filterObj.filters = [...filterObj.filters, ...columnFilters];
      }
      var phIds = [];
    if (searchTerms.pharmacyids.length !== undefined && searchTerms.pharmacyids.length > 0) {
      phIds = Array.isArray(searchTerms.pharmacyids)
    ? searchTerms.pharmacyids.map(item => item["value"])
    : [];
    }
    var covids = [];
    if ( searchTerms.ceIds.length !== undefined && searchTerms.ceIds.length > 0) {
      covids = Array.isArray(searchTerms.ceIds)
      ? searchTerms.ceIds.map(item => item["value"])
      :[];
    }
      var additionalCriteria = {};
      additionalCriteria.IsSelectedColumn = false;
      filterObj.ThirdPartyAdminID = searchTerms.thirdPartyAdminID;
      filterObj.PharmacyIds = phIds;
      filterObj.CoveredEntityIDS = covids;
      filterObj.StartDate = searchTerms.startDate;
      filterObj.EndDate = searchTerms.endDate;
      filterObj.Year = searchTerms.Year;
      filterObj.Month = searchTerms.Month;
    filterObj.daterangeid = searchTerms.dateRange 
      //additionalCriteria.OrgId = orgId.organizationID;
      var payload = {};
      payload.tenantID = tenantID;
      payload.gridCode = "purchaseorderclaimreports";
      payload.fileTypeCode = "csv";
      payload.criteria = JSON.stringify(filterObj);
      payload.additionalCriteria = JSON.stringify(additionalCriteria);
      const { data } = await API.post(`export/queue`, payload, {
        hasExport: true,
      });
  
  };
  const slelectedExportPOcoloumms = async () => {
     const filterObj = cloneDeep(search);
      if (columnFilters && columnFilters.length > 0) {
        filterObj.filters = [...filterObj.filters, ...columnFilters];
      }
      var phIds = [];
    if (searchTerms.pharmacyids.length !== undefined && searchTerms.pharmacyids.length > 0) {
      phIds = Array.isArray(searchTerms.pharmacyids)
    ? searchTerms.pharmacyids.map(item => item["value"])
    : [];
    }
    var covids = [];
    if ( searchTerms.ceIds.length !== undefined && searchTerms.ceIds.length > 0) {
      covids = Array.isArray(searchTerms.ceIds)
      ? searchTerms.ceIds.map(item => item["value"])
      :[];
    }
      var additionalCriteria = {};
      additionalCriteria.IsSelectedColumn = true;
      filterObj.ThirdPartyAdminID = searchTerms.thirdPartyAdminID;
      filterObj.PharmacyIds = phIds;
      filterObj.CoveredEntityIDS = covids;
      filterObj.StartDate = searchTerms.startDate;
      filterObj.EndDate = searchTerms.endDate;
      filterObj.Year = searchTerms.Year;
      filterObj.Month = searchTerms.Month;
    filterObj.daterangeid = searchTerms.dateRange 
      //additionalCriteria.OrgId = orgId.organizationID;
      var payload = {};
      payload.tenantID = tenantID;
      payload.gridCode = "purchaseorderclaimreports";
      payload.fileTypeCode = "csv";
      payload.criteria = JSON.stringify(filterObj);
      payload.additionalCriteria = JSON.stringify(additionalCriteria);
      const { data } = await API.post(`export/queue`, payload, {
        hasExport: true,
     });
  };

  const handleExportClaimReports = async () => {
         const filterObj = cloneDeep(search);
      if (columnFilters && columnFilters.length > 0) {
        filterObj.filters = [...filterObj.filters, ...columnFilters];
      }
      var phIds = [];
    if (searchTerms.pharmacyids.length !== undefined && searchTerms.pharmacyids.length > 0) {
      phIds = Array.isArray(searchTerms.pharmacyids)
    ? searchTerms.pharmacyids.map(item => item["value"])
    : [];
    }
    var covids = [];
    if ( searchTerms.ceIds.length !== undefined && searchTerms.ceIds.length > 0) {
      covids = Array.isArray(searchTerms.ceIds)
      ? searchTerms.ceIds.map(item => item["value"])
      :[];
    }
      var additionalCriteria = {};
      additionalCriteria.IsSelectedColumn = false;
      filterObj.ThirdPartyAdminID = searchTerms.thirdPartyAdminID;
      filterObj.PharmacyIds = phIds;
      filterObj.CoveredEntityIDS = covids;
      filterObj.StartDate = searchTerms.startDate;
      filterObj.EndDate = searchTerms.endDate;
      filterObj.Year = searchTerms.Year;
      filterObj.Month = searchTerms.Month;
      filterObj.daterangeid = searchTerms.dateRange 
      //additionalCriteria.OrgId = orgId.organizationID;
      var payload = {};
      payload.tenantID = tenantID;
      payload.gridCode = "claimreports";
      payload.fileTypeCode = "csv";
      payload.criteria = JSON.stringify(filterObj);
      payload.additionalCriteria = JSON.stringify(additionalCriteria);
      const { data } = await API.post(`export/queue`, payload, {
        hasExport: true,
      });
      
  };

  const selelectedExportClaimColoumms = async () => {
    const filterObj = cloneDeep(search);
      if (columnFilters && columnFilters.length > 0) {
        filterObj.filters = [...filterObj.filters, ...columnFilters];
      }
      var phIds = [];
    if (searchTerms.pharmacyids.length !== undefined && searchTerms.pharmacyids.length > 0) {
      phIds = Array.isArray(searchTerms.pharmacyids)
    ? searchTerms.pharmacyids.map(item => item["value"])
    : [];
    }
    var covids = [];
    if ( searchTerms.ceIds.length !== undefined && searchTerms.ceIds.length > 0) {
      covids = Array.isArray(searchTerms.ceIds)
      ? searchTerms.ceIds.map(item => item["value"])
      :[];
    }
      var additionalCriteria = {};
      additionalCriteria.IsSelectedColumn = true;
      filterObj.ThirdPartyAdminID = searchTerms.thirdPartyAdminID;
      filterObj.PharmacyIds = phIds;
      filterObj.CoveredEntityIDS = covids;
      filterObj.StartDate = searchTerms.startDate;
      filterObj.EndDate = searchTerms.endDate;
      filterObj.Year = searchTerms.Year;
      filterObj.Month = searchTerms.Month;
    filterObj.daterangeid = searchTerms.dateRange 

      //additionalCriteria.OrgId = orgId.organizationID;
      var payload = {};
      payload.tenantID = tenantID;
      payload.gridCode = "claimreports";
      payload.fileTypeCode = "csv";
      payload.criteria = JSON.stringify(filterObj);
      payload.additionalCriteria = JSON.stringify(additionalCriteria);
      const { data } = await API.post(`export/queue`, payload, {
        hasExport: true,
      });
  };
  const handleExportReplenishedReports = async () => {
      const filterObj = cloneDeep(search);
      if (columnFilters && columnFilters.length > 0) {
        filterObj.filters = [...filterObj.filters, ...columnFilters];
      }
      var phIds = [];
    if (searchTerms.pharmacyids.length !== undefined && searchTerms.pharmacyids.length > 0) {
      phIds = Array.isArray(searchTerms.pharmacyids)
    ? searchTerms.pharmacyids.map(item => item["value"])
    : [];
    }
    var covids = [];
    if ( searchTerms.ceIds.length !== undefined && searchTerms.ceIds.length > 0) {
      covids = Array.isArray(searchTerms.ceIds)
      ? searchTerms.ceIds.map(item => item["value"])
      :[];
    }

    //var filterObj = columnFilters
      var additionalCriteria = {};
      additionalCriteria.IsSelectedColumn = false;
      filterObj.IsSelectedColumn = false;
      filterObj.ThirdPartyAdminID = searchTerms.thirdPartyAdminID;
      filterObj.PharmacyIds = phIds;
      filterObj.CoveredEntityIDS = covids;
      filterObj.StartDate = searchTerms.startDate;
      filterObj.EndDate = searchTerms.endDate;
      filterObj.Year = searchTerms.Year;
      filterObj.Month = searchTerms.Month;
      filterObj.daterangeid = searchTerms.dateRange 
      //additionalCriteria.OrgId = orgId.organizationID;
      var payload = {};
      payload.tenantID = tenantID;
      payload.gridCode = "replenishedclaimreports";
      payload.fileTypeCode = "csv";
      payload.criteria = JSON.stringify(filterObj);
      payload.additionalCriteria = JSON.stringify(additionalCriteria);
      const { data } = await API.post(`export/queue`, payload, {
        hasExport: true,
      });
  };
  const slelectedExportReplenishedcoloumms = async () => {
     const filterObj = cloneDeep(search);
      if (columnFilters && columnFilters.length > 0) {
        filterObj.filters = [...filterObj.filters, ...columnFilters];
      }
      var phIds = [];
    if (searchTerms.pharmacyids.length !== undefined && searchTerms.pharmacyids.length > 0) {
      phIds = Array.isArray(searchTerms.pharmacyids)
    ? searchTerms.pharmacyids.map(item => item["value"])
    : [];
    }
    var covids = [];
    if ( searchTerms.ceIds.length !== undefined && searchTerms.ceIds.length > 0) {
      covids = Array.isArray(searchTerms.ceIds)
      ? searchTerms.ceIds.map(item => item["value"])
      :[];
    }
      var additionalCriteria = {};
      additionalCriteria.IsSelectedColumn = true;
      filterObj.ThirdPartyAdminID = searchTerms.thirdPartyAdminID;
      filterObj.PharmacyIds = phIds;
      filterObj.CoveredEntityIDS = covids;
      filterObj.StartDate = searchTerms.startDate;
      filterObj.EndDate = searchTerms.endDate;
      filterObj.Year = searchTerms.Year;
      filterObj.Month = searchTerms.Month;
    filterObj.daterangeid = searchTerms.dateRange 
      //additionalCriteria.OrgId = orgId.organizationID;
      var payload = {};
      payload.tenantID = tenantID;
      payload.gridCode = "replenishedclaimreports";
      payload.fileTypeCode = "csv";
      payload.criteria = JSON.stringify(filterObj);
      payload.additionalCriteria = JSON.stringify(additionalCriteria);
      const { data } = await API.post(`export/queue`, payload, {
        hasExport: true,
      });
  };

  const handleExportNonReplenishedReports = async () => {
     const filterObj = cloneDeep(search);
      if (columnFilters && columnFilters.length > 0) {
        filterObj.filters = [...filterObj.filters, ...columnFilters];
      }
      var phIds = [];
    if (searchTerms.pharmacyids.length !== undefined && searchTerms.pharmacyids.length > 0) {
      phIds = Array.isArray(searchTerms.pharmacyids)
    ? searchTerms.pharmacyids.map(item => item["value"])
    : [];
    }
    var covids = [];
    if ( searchTerms.ceIds.length !== undefined && searchTerms.ceIds.length > 0) {
      covids = Array.isArray(searchTerms.ceIds)
      ? searchTerms.ceIds.map(item => item["value"])
      :[];
    }
      var additionalCriteria = {};
      additionalCriteria.IsSelectedColumn = false;
      filterObj.ThirdPartyAdminID = searchTerms.thirdPartyAdminID;
      filterObj.PharmacyIds = phIds;
      filterObj.CoveredEntityIDS = covids;
      filterObj.StartDate = searchTerms.startDate;
      filterObj.EndDate = searchTerms.endDate;
      filterObj.Year = searchTerms.Year;
      filterObj.Month = searchTerms.Month;
      filterObj.daterangeid = searchTerms.dateRange 
      //additionalCriteria.OrgId = orgId.organizationID;
      var payload = {};
      payload.tenantID = tenantID;
      payload.gridCode = "nonreplenishedclaimreports";
      payload.fileTypeCode = "csv";
      payload.criteria = JSON.stringify(filterObj);
      payload.additionalCriteria = JSON.stringify(additionalCriteria);
      const { data } = await API.post(`export/queue`, payload, {
        hasExport: true,
      });
  };
  const handleExportNonDerivedClaimsReports = async () => {
    const filterObj = cloneDeep(search);
      if (columnFilters && columnFilters.length > 0) {
        filterObj.filters = [...filterObj.filters, ...columnFilters];
      }
      var phIds = [];
    if (searchTerms.pharmacyids.length !== undefined && searchTerms.pharmacyids.length > 0) {
      phIds = Array.isArray(searchTerms.pharmacyids)
    ? searchTerms.pharmacyids.map(item => item["value"])
    : [];
    }
    var covids = [];
    if ( searchTerms.ceIds.length !== undefined && searchTerms.ceIds.length > 0) {
      covids = Array.isArray(searchTerms.ceIds)
      ? searchTerms.ceIds.map(item => item["value"])
      :[];
    }
      var additionalCriteria = {};
      additionalCriteria.IsSelectedColumn = false;
      filterObj.ThirdPartyAdminID = searchTerms.thirdPartyAdminID;
      filterObj.PharmacyIds = phIds;
      filterObj.CoveredEntityIDS = covids;
      filterObj.StartDate = searchTerms.startDate;
      filterObj.EndDate = searchTerms.endDate;
      filterObj.Year = searchTerms.Year;
      filterObj.Month = searchTerms.Month;
    filterObj.daterangeid = searchTerms.dateRange 
      //additionalCriteria.OrgId = orgId.organizationID;
      var payload = {};
      payload.tenantID = tenantID;
      payload.gridCode = "nonderivedclaimreports";
      payload.fileTypeCode = "csv";
      payload.criteria = JSON.stringify(filterObj);
      payload.additionalCriteria = JSON.stringify(additionalCriteria);
      const { data } = await API.post(`export/queue`, payload, {
        hasExport: true,
      });
  };

  const slelectedExportNonDerivedClaimscoloumms = async () => {
    const filterObj = cloneDeep(search);
      if (columnFilters && columnFilters.length > 0) {
        filterObj.filters = [...filterObj.filters, ...columnFilters];
      }
      var phIds = [];
    if (searchTerms.pharmacyids.length !== undefined && searchTerms.pharmacyids.length > 0) {
      phIds = Array.isArray(searchTerms.pharmacyids)
    ? searchTerms.pharmacyids.map(item => item["value"])
    : [];
    }
    var covids = [];
    if ( searchTerms.ceIds.length !== undefined && searchTerms.ceIds.length > 0) {
      covids = Array.isArray(searchTerms.ceIds)
      ? searchTerms.ceIds.map(item => item["value"])
      :[];
    }
      var additionalCriteria = {};
      additionalCriteria.IsSelectedColumn = true;
      filterObj.ThirdPartyAdminID = searchTerms.thirdPartyAdminID;
      filterObj.PharmacyIds = phIds;
      filterObj.CoveredEntityIDS = covids;
      filterObj.StartDate = searchTerms.startDate;
      filterObj.EndDate = searchTerms.endDate;
      filterObj.Year = searchTerms.Year;
      filterObj.Month = searchTerms.Month;
    filterObj.daterangeid = searchTerms.dateRange 

      //additionalCriteria.OrgId = orgId.organizationID;
      var payload = {};
      payload.tenantID = tenantID;
      payload.gridCode = "nonderivedclaimreports";
      payload.fileTypeCode = "csv";
      payload.criteria = JSON.stringify(filterObj);
      payload.additionalCriteria = JSON.stringify(additionalCriteria);
      const { data } = await API.post(`export/queue`, payload, {
        hasExport: true,
      });
  };
  const slelectedExportNonReplenishedcoloumms = async () => {
     const filterObj = cloneDeep(search);
      if (columnFilters && columnFilters.length > 0) {
        filterObj.filters = [...filterObj.filters, ...columnFilters];
      }
      var phIds = [];
    if (searchTerms.pharmacyids.length !== undefined && searchTerms.pharmacyids.length > 0) {
      phIds = Array.isArray(searchTerms.pharmacyids)
    ? searchTerms.pharmacyids.map(item => item["value"])
    : [];
    }
    var covids = [];
    if ( searchTerms.ceIds.length !== undefined && searchTerms.ceIds.length > 0) {
      covids = Array.isArray(searchTerms.ceIds)
      ? searchTerms.ceIds.map(item => item["value"])
      :[];
    }
      var additionalCriteria = {};
      additionalCriteria.IsSelectedColumn = true;
      filterObj.ThirdPartyAdminID = searchTerms.thirdPartyAdminID;
      filterObj.PharmacyIds = phIds;
      filterObj.CoveredEntityIDS = covids;
      filterObj.StartDate = searchTerms.startDate;
      filterObj.EndDate = searchTerms.endDate;
      filterObj.Year = searchTerms.Year;
      filterObj.Month = searchTerms.Month;
    filterObj.daterangeid = searchTerms.dateRange 
      //additionalCriteria.OrgId = orgId.organizationID;
      var payload = {};
      payload.tenantID = tenantID;
      payload.gridCode = "nonreplenishedclaimreports";
      payload.fileTypeCode = "csv";
      payload.criteria = JSON.stringify(filterObj);
      payload.additionalCriteria = JSON.stringify(additionalCriteria);
      const { data } = await API.post(`export/queue`, payload, {
        hasExport: true,
      });
  };

  const handleExportInvoicedReports = async () => {
    pageFilters.filters = { ...search };
    const { access_token } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Reports/ExportInvoicedReports?access_token=${access_token}`;
    onExport(action, pageFilters);
  };

  const handlePageChange = (filter, haveColFilter) => {
    if (haveColFilter) {
      handlefetchbasedOnreportType(reportType, filter);
    } else {
      handlefetchbasedOnreportType(reportType, filter);
    }
    reports.search = { ...reports.search, ...filter };
    setStates("reports", reports);
  };

  const handleReset = () => {
    setData([]);
    setReportType("");
    setTotalItem(0);
  };

  const handleSearchColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(search);
    searchTerms.dateRangeID = searchTerms.dateRange;
    filterObj.filters = [...filterObj.filters, ...columnFilters];
   setColumnFilters(columnFilters)
    await handlefetchbasedOnreportType(reportType, filterObj);
  };

  return (
    <div>
       {loading && <Loader opacity={0.01} color='black' />}
           <Container fluid className="width_info">
      <div className={collapseSider ? "mb-0" : "mb-3"}>
        <Card className="border-0 shadow-top">
          <CardBody  hidden={collapseSider} className="">
            <ErrorBoundary>
            <SearchReports onReset={handleReset} onSearch={handleSearch} loading={loading} />
            </ErrorBoundary>
          </CardBody>
          </Card>
          </div>
          <Card className="border-0 shadow-top">
          <CardBody className="">
            <ErrorBoundary>   
            <div>
              {(pageFilters.reportType === 1 || reportType=='') && (
                <ReportClaimTable
                  data={data}
                 // loading={loading}
                  filters={search}
                  totalSize={totalItem}
                  AllExport={handleExportClaimReports}
                  selelectedExportClaimColoumms={selelectedExportClaimColoumms}
                  refetch={refetch}
                  onPageChange={handlePageChange}
                  onSearchColumnFilters={handleSearchColumnFilters}
                  tenantID={tenantID}
                  pageFilters={pageFilters}
                  collapseSider={collapseSider}
                  toggleSider={toggleSider}
                />
              )}
              {reportType === 2 && (
                <ReportReplenishedTable
                  data={data}
                 // loading={loading}
                  filters={search}
                  totalSize={totalItem}
                  AllExport={handleExportReplenishedReports}
                  slelectedExportReplenishedcoloumms={
                    slelectedExportReplenishedcoloumms
                  }
                  refetch={refetch}
                  toggleSider={toggleSider}
                  onPageChange={handlePageChange}
                  onSearchColumnFilters={handleSearchColumnFilters}
                  tenantID={tenantID}
                  pageFilters={pageFilters}
                  collapseSider={collapseSider}
                />
              )}
              {reportType === 3 && (
                <ReportNonReplenishedTable
                  data={data}
                 // loading={loading}
                  filters={search}
                  totalSize={totalItem}
                  AllExport={handleExportNonReplenishedReports}
                  slelectedExportNonReplenishedcoloumms={
                    slelectedExportNonReplenishedcoloumms
                  }
                  refetch={refetch}
                  onPageChange={handlePageChange}
                  onSearchColumnFilters={handleSearchColumnFilters}
                  tenantID={tenantID}
                  pageFilters={pageFilters}
                  collapseSider={collapseSider}
                  toggleSider={toggleSider}
                />
              )}
              {reportType === 4 && (
                <ReportInvoicedClaimsTable
                  data={data}
                 // loading={loading}
                  filters={search}
                  totalSize={totalItem}
                  onExport={handleExportInvoicedReports}
                  refetch={refetch}
                  onPageChange={handlePageChange}
                  onSearchColumnFilters={handleSearchColumnFilters}
                  collapseSider={collapseSider}
                  toggleSider={toggleSider}
                />
              )}
              {reportType === 5 && (
                <ReportPODetailsTable
                  data={data}
               //   loading={loading}
                  filters={search}
                  totalSize={totalItem}
                  AllExport={handlePOExport}
                  slelectedExportPOcoloumms={slelectedExportPOcoloumms}
                  refetch={refetch}
                  onPageChange={handlePageChange}
                  tenantID={tenantID}
                  pageFilters={pageFilters}
                  onSearchColumnFilters={handleSearchColumnFilters}
                  collapseSider={collapseSider}
                  toggleSider={toggleSider}
                />
              )}
              {reportType === 6 && (
                <NonDerivedClaimTable
                 data={data}
                 // loading={loading}
                  filters={search}
                  totalSize={totalItem}
                  AllExport={handleExportNonDerivedClaimsReports}
                  slelectedExportPOcoloumms={slelectedExportNonDerivedClaimscoloumms}
                  refetch={refetch}
                  onPageChange={handlePageChange}
                  tenantID={tenantID}
                  pageFilters={pageFilters}
                  onSearchColumnFilters={handleSearchColumnFilters}
                  collapseSider={collapseSider}
                  toggleSider={toggleSider}
                />
              )
              }
            </div>
          </ErrorBoundary>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default Reports;
